import { ArrowDown } from 'lucide-react';
import { heroContent, eventInfo } from '../../data/landingData';
import { Countdown, SpotsRemaining } from './Countdown';

export const Hero = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image with zoom animation */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 bg-cover bg-center animate-hero-zoom"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1614595145313-c7e1765be457?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxibGFjayUyMG1lbiUyMG1lZGl0YXRpb24lMjBuYXR1cmV8ZW58MHx8fHwxNzc0NzAzOTIyfDA&ixlib=rb-4.1.0&q=85')`
          }}
        />
        {/* Overlay gradients */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/80 via-transparent to-[#0A0A0A]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto pt-24 pb-16">
        {/* Event details badge */}
        <div className="inline-flex items-center gap-2 glass rounded-full px-5 py-2 mb-8">
          <span className="text-[#D4AF37] font-manrope text-sm font-medium">
            {eventInfo.dates} ({eventInfo.daysFormat})
          </span>
          <span className="text-zinc-600">•</span>
          <span className="text-zinc-400 font-manrope text-sm">
            {eventInfo.location}
          </span>
        </div>

        {/* Main headline */}
        <h1 className="font-cormorant text-5xl md:text-7xl lg:text-8xl font-medium text-white mb-6 tracking-tight">
          {heroContent.headline}
        </h1>

        {/* Subheadline */}
        <p className="font-manrope text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto mb-10 leading-relaxed">
          {heroContent.subheadline}
        </p>

        {/* Countdown Timer */}
        <div className="mb-8">
          <p className="text-zinc-500 font-manrope text-sm uppercase tracking-widest mb-4">
            Retreat begins in
          </p>
          <div className="flex justify-center">
            <Countdown />
          </div>
        </div>

        {/* Spots Remaining */}
        <div className="mb-10 flex justify-center">
          <SpotsRemaining />
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#pricing"
            className="bg-[#D4AF37] text-[#0A0A0A] px-10 py-4 rounded-full font-manrope font-bold text-lg hover:bg-[#B8860B] transition-all hover:-translate-y-1 gold-glow"
            data-testid="hero-cta-primary"
          >
            {heroContent.ctaPrimary}
          </a>
          <a
            href="#brotherhood"
            className="text-white border border-white/20 px-10 py-4 rounded-full font-manrope font-medium hover:bg-white/5 transition-all"
            data-testid="hero-cta-secondary"
          >
            {heroContent.ctaSecondary}
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#brotherhood" className="text-zinc-500 hover:text-white transition-colors">
          <ArrowDown className="w-6 h-6" />
        </a>
      </div>
    </section>
  );
};
